import { useMemo } from "react";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useAvailableTimeSlots } from "@/features/availability/hooks/useAvailabilities";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { businessDayBounds } from "../utils/bookingTime";

export function useBookingWindows(params: { dateKey: string; locationId: string; excludeId?: string }) {
  const { business, businessId } = useCurrentBusiness();
  const { user } = useAuth();
  const zone = business?.timezone ?? "UTC";
  const bounds = useMemo(() => businessDayBounds(params.dateKey, zone), [params.dateKey, zone]);
  const query = useAvailableTimeSlots({
    userId: user?.id ?? "",
    businessId: businessId ?? "",
    locationId: params.locationId,
    // Include neighboring days so cross-midnight buffers are checked by the server.
    startAt: new Date(bounds.startAt.getTime() - 86_400_000),
    endAt: new Date(bounds.endAt.getTime() + 86_400_000),
    excludeAppointmentId: params.excludeId,
  });
  return { ...query, bounds, enabled: !!user && !!businessId && !!params.locationId };
}
